export default __webpack_public_path__ + "static/media/fluigiLogo.402b6b94.png";